export const IDENTITY_CONFIG = {
  authority: process.env.REACT_APP_AUTH_URL,
  client_id: process.env.REACT_APP_AUTH_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_AUTH_REDIRECT_URL,
  post_logout_redirect_uri: process.env.REACT_APP_AUTH_LOGOUT_REDIRECT_URL,
  response_type: 'code',
  scope: 'openid profile email',
};

export const METADATA_CONFIG = {
  issuer: process.env.REACT_APP_AUTH_URL,
  authorization_endpoint: `${process.env.REACT_APP_AUTH_ENDPOINT_BASE_URL}/oauth2/authorize`,
  token_endpoint: `${process.env.REACT_APP_AUTH_ENDPOINT_BASE_URL}/oauth2/token`,
  userinfo_endpoint: `${process.env.REACT_APP_AUTH_ENDPOINT_BASE_URL}/oauth2/userInfo`,
  end_session_endpoint: `${process.env.REACT_APP_AUTH_ENDPOINT_BASE_URL}/logout`,
  revocation_endpoint: `${process.env.REACT_APP_AUTH_ENDPOINT_BASE_URL}/oauth2/revoke`,
  jwks_uri: `${process.env.REACT_APP_AUTH_URL}/.well-known/jwks.json`,
};
